export const ALL_PRODUCTS_CATEGORY_NAME = 'All Products'
export const ALL_PRODUCTS_CATEGORY_ID = 'all-products'
export const OCCASIONS_CATEGORY_NAME = 'Occasions'
export const OCCASIONS_CATEGORY_ID = 'occasions'
